// extracted by mini-css-extract-plugin
var _1 = "iQ_c5VwL_eCOoxK3uOzN";
var _2 = "pgM34F4AU329kvJ4ejQO";
var _3 = "kPRmwD33CTbbCQxk7GQa";
export { _1 as "developmentMode", _2 as "safeZoneContainer", _3 as "safeZoneSpacer" }
